module.exports = __webpack_public_path__ + "static/img/iCloudPhotos.ba99a36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/iCloudPhotos.svg
// module id = QJwH
// module chunks = 2